import { Input, Component } from '@angular/core';

@Component({
  selector: 'eiq-break-line',
  templateUrl: './break-line.component.html',
  styleUrls: ['./break-line.component.scss', '_break-line-theme.component.scss']
})
export class BreakLineComponent {
  @Input() color: 'light' = 'light';
}
